import Blue from '~/core';

new Blue({
  name: 'Anchors',
  selector: '.anchors',
  setup(anchors) {
    let headerHeight = 0;
    let scroll = 0;
    let hasAnchors = true;
    let scrolling = false
    let activeAnchor = -1;

    const anchorOffset = 50;
    const scrollSpeed = 1000;
    const header = document.querySelector('.header');
    const section = anchors.querySelector('section');
    const anchorElements = anchors.querySelectorAll('.anchors__link');
    const anchorPageElements = getPageAnchorElements();

    if (!hasAnchors) showWarning('no-anchors');

    headerHeight = getHeaderHeight();
    setAnchorTop();

    initEvents();
    checkVisibleAnchor();

    function initEvents() {
      setUpObserver();
      setUpClickEvents();
    }

    function setUpObserver() {
      const resizeObserver = new ResizeObserver(entries => {
        const newHeight = getHeaderHeight();
        if (headerHeight === newHeight) return;
        setAnchorTop();
      });

      resizeObserver.observe(header);
    }

    function setUpClickEvents() {
      anchorElements.forEach((el, index) => {
        el.addEventListener('click', e => {
          e.preventDefault();
          setActiveAnchor(el);
          const target = anchorPageElements[index];
          const y = target.getBoundingClientRect().top + window.scrollY - headerHeight - anchorOffset;
          scrollTo(y, scrollSpeed, easeOutBack);
        });
      });
    }

    function checkVisibleAnchor() {
      if (!scrolling && scroll !== window.scrollY){
        let closest = null;
        let closestDistance = Infinity;

        scroll = window.scrollY;

        anchorPageElements.forEach((el, index) => {
          const rect = el.getBoundingClientRect();
          const distance = Math.abs(window.innerHeight / 3 - rect.top);

          if (distance < closestDistance) {
            closest = index;
            closestDistance = distance;
          }
        });

        if (closest !== null && closest !== activeAnchor) 
          setActiveAnchor(anchorElements[closest], closest);

        if (closest === anchorPageElements.length - 1) {
          const bottomOffset = 
            anchorPageElements[closest].getBoundingClientRect().bottom - 
            headerHeight - anchors.offsetHeight;

          if (bottomOffset < 0) 
            anchors.style.transform = `translateY(${bottomOffset}px)`;
          else 
            anchors.style.transform = '';
        }
      }

      requestAnimationFrame(checkVisibleAnchor);
    }

    function getHeaderHeight() {
      headerHeight = header ? header.offsetHeight : 0;
    }

    function setAnchorTop() {
      anchors.style.top = `${headerHeight}px`;
    }

    function setActiveAnchor(anchor, index) {
      activeAnchor = index;
      anchorElements.forEach(el => el.classList.remove('active'));
      section.scrollTo({ left:anchor.offsetLeft - section.offsetLeft - 15,  behavior: 'smooth' });
      anchor.classList.add('active');
    }

    function getPageAnchorElements() {
      return [...anchorElements].map(a => {
        const href = a.getAttribute('href');
        const target = document.querySelector(href);
        if (!target) hasAnchors = false;
        return target;
      });
    }

    function scrollTo(Y, duration, easingFunction, callback) {
      var start = Date.now(),
        elem = !isNaN(document.documentElement.scrollTop)
          ? document.documentElement
          : document.body,
        from = elem.scrollTop;

      if (from === Y) {
        callback();
        return;
      }

      scrolling = true;

      function scroll(t) {
        var currentTime = Date.now(),
          time = Math.min(1, (currentTime - start) / duration),
          easedT = easingFunction(time);

        elem.scrollTop = easedT * (Y - from) + from;

        if (time < 1) requestAnimationFrame(scroll);
        else {
          scrolling = false;
          if (callback) callback();
        }
      }

      requestAnimationFrame(scroll);
    }

    function easeOutBack(x) {
      const c1 = 1;
      const c3 = c1 + 1;
      return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);
    }


    function showWarning(type) {
      switch (type) {
        case 'no-anchors':
          console.warn('Page Anchors: Anchor links do not have corresponding elements on the page');
          anchorElements.forEach((a, i) => {
            if (!anchorPageElements[i]) {
              console.warn('Page Anchors: No corresponding element found for anchor link', a);
            }
          });
          break;

        default:
          console.warn('Page Anchors: An error occurred');
          break;
      }
    }
  },
});
